import mapboxgl from "mapbox-gl";

const prettyDescription = (data) => {
    let result = '<table>';
    for (const [key, value] of Object.entries(data)) {
      result += `<tr><th id="key">${key}</th><th id="value">${value}</th></tr>`
    }
    result += '</table>';
    return result;
}

const popupAdasisDataValue = (map, data) => {
    const { mpp, eventTimestamps, ...rest } = data.properties;
    new mapboxgl.Popup().setLngLat(data.lngLat)
        .setHTML(prettyDescription({ ...rest, ...JSON.parse(eventTimestamps) }))
        .addTo(map);
}

const handlers = [
    { 'layer_ids': 'Adasis/Messages', event: 'click', cb: popupAdasisDataValue }
];

export default handlers;